module.exports = __webpack_public_path__ + "img/logo-rever.78c66ca5.png";